import { useEffect, useReducer } from 'react';
import axios from 'axios';

const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_INIT':
      return { ...state, isLoading: true, isError: false };
    case 'SUBMIT_SUCCESS':
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        errorMessage: '',
        response: action.payload,
        requestCompleted: true,
      };
    case 'SUBMIT_FAILURE':
      return {
        ...state,
        isLoading: false,
        hasErrored: true,
        errorData: action.payload,
        errorMessage: 'Data Submission Failed',
      };
  }
};

const useUnauthorizedAxiosSubmit = (url, data, option) => {
  const [state, dispatch] = useReducer(dataFetchReducer, {
    isLoading: false,
    hasErrored: false,
    errorMessage: '',
    response: null,
  });

  useEffect(() => {
    let didCancel = false;

    const submitData = async () => {
      dispatch({ type: 'SUBMIT_INIT' });

      try {
        const axiosClient = axios.create();
        let response;
        option === 'put'
          ? (response = await axiosClient.put(url, data))
          : (response = await axiosClient.post(url, data));

        if (!didCancel) {
          dispatch({ type: 'SUBMIT_SUCCESS', payload: response.data });
        }
      } catch (err) {
        if (!didCancel) {
          dispatch({ type: 'SUBMIT_FAILURE', payload: err?.response?.data });
        }
      }
    };

    if (data) {
      submitData();
    }

    return () => {
      didCancel = true;
    };
  }, [data]);

  return { ...state };
};

export default useUnauthorizedAxiosSubmit;
